<template>
  <div class="bg mediaPublishDetail">
    <headline :params="headLines" :statusName="detail.status_name" />
    <div v-if="detail.is_expired && detail.platform_key == 'b_plus'" class="err-container">
        <img src="../../common/previewBox/assets/err.png" alt="">
        <p>
            {{detail.platform_title}}  平台发布失败，请
            <i @click="reS">重新授权</i>
            或联系管理员
        </p>
    </div>
    <notice v-if="errMessage" posType="center" hideClose="true" :message="errMessage"></notice>
    <div v-if="isInit" class="container">
      <div v-if="detail.platform_key != 'playlist'" class="content">
        <div class="leftContainer">
          <article :class="{center: history_id}">
            <div class="top">
              <div class="title">
                <h4 :title="detail.title" v-if="detail">{{detail.title}}</h4>
                <span class="remainText" v-if="detail && detail.status == 0 && detail.remain_text">{{detail.remain_text}}</span>
              </div>
              <div class="statisticContainer">
                <div class="l">
                  <div class="sub">
                    <label style="margin: 0">发布平台：</label>
                    <span>{{detail.platform_title}}</span>
                    <!-- <label v-if="detail.platform_key == 'new_media_knews'" style="margin: 0">来源：</label>
                    <span v-if="detail.platform_key == 'new_media_knews'">{{detail.from}}</span>
                    <label v-if="detail.platform_key == 'new_media_knews' && detail.type == 6" style="margin: 0">版权：</label>
                    <span v-if="detail.platform_key == 'new_media_knews' && detail.type == 6">{{detail.copyright}}</span> -->
                  </div>
                  <div class="row">
                    <div class="sub">
                      <label style="margin: 0">发布人：</label>
                      <span>{{detail.user_name}}</span>
                    </div>
                    <div class="sub">
                      <label style="margin: 0">发布时间：</label>
                      <span>{{detail.raw_update_time}}</span>
                    </div>
                  </div>
                </div>
                <div v-if="detail.platform_key == 'new_media_knews' && detail.status == 5" class="r">
                  <!-- <div class="fav"><i></i>123</div> -->
                  <!-- <div class="t">
                    <div class="watch"><i></i>{{(detail.knews_data && detail.knews_data.views && detail.knews_data.views.num) || 0}}</div>
                    <div class="fav"><i></i>{{(detail.knews_data && detail.knews_data.likes && detail.knews_data.likes.num) || 0}}</div>
                    <div class="share"><i></i>{{(detail.knews_data && detail.knews_data.shares && detail.knews_data.shares.num) || 0}}</div>
                    <div class="comment"><i></i>{{(detail.knews_data && detail.knews_data.comments && detail.knews_data.comments.num) || 0}}</div>
                  </div>
                  <div class="b"><div v-if="detail.platform_key == 'dy'" class="newNotice">仅显示最新一次推送数据结果</div></div> -->
                </div>
                <div v-if="detail.platform_key == 'dy'" class="r">
                  <!-- <div class="t">
                    <div class="fav"><i></i>{{detail.dy_data && detail.dy_data.likes && detail.dy_data.likes.num}}</div>
                    <div class="comment"><i></i>{{detail.dy_data && detail.dy_data.comments && detail.dy_data.comments.num}}</div>
                    <div class="num"><i></i>{{detail.dy_data && detail.dy_data.views && detail.dy_data.views.num}}</div>
                    <div class="share"><i></i>{{detail.dy_data && detail.dy_data.shares && detail.dy_data.shares.num}}</div>
                  </div>
                  <div class="b"><div v-if="detail.platform_key == 'dy'" class="newNotice">仅显示最新一次推送数据结果</div></div> -->
                </div>
              </div>
              <!-- <div v-if="detail.platform_key != 'new_media_knews'" class="sub">
                  <label style="margin: 0">发布人：</label>
                  <span>{{detail.user_name}}</span>
              </div>
              <div v-if="detail.platform_key != 'new_media_knews'" class="sub">
                  <label style="margin: 0">发布时间：</label>
                  <span>{{detail.raw_update_time}}</span>
              </div> -->

              <div class="line"></div>

            </div>
            <div class="videoContent">
              <video ref="videoDom" v-show="detail.video_url" :src="detail.video_url" controls controlslist="nodownload"></video>
              <div v-if="detail.type == 5" class="articleContent" v-html="detail.info"></div>
              <!-- <div v-if="detail.type != 5 && detail.info" class="writeArticleContent">
                <p class="title">【简介】</p>
                <div class="contents" v-html="detail.info"></div>
              </div> -->
              <div v-if="detail.type != 5" v-html="detail.content" class="writeContent"></div>
            </div>
          </article>

          <div v-show="detail.platform_key != 'five_star_sports_cms' || (detail.platform_key == 'five_star_sports_cms' && detail.tags && detail.tags.length > 0)" :class="{bottomTag: true,un: !showBottomTag}">
            <div class="title">
              <div class="l">标签</div>
              <img @click="showBottomTag = !showBottomTag" class="r" :src="showBottomTag?icons.up:icons.down" alt="icons" />
            </div>

            <div v-if="showBottomTag" class="tagContent">
              <div v-if="detail && detail.tags && detail.tags.length > 0 && (detail.platform_key == 'new_media_knews' || detail.platform_key == 'dy' || detail.platform_key == 'five_star_sports_cms' || detail.platform_key == 'bilibili')" class="tag first">
                <ul v-if="detail.platform_key == 'new_media_knews'&&showBottomTag">
                    <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
                </ul>

                <ul v-if="detail.platform_key == 'five_star_sports_cms'&&showBottomTag">
                    <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
                </ul>

                <ul v-if="detail.platform_key == 'bilibili'&&showBottomTag">
                    <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
                </ul>

                <ul v-if="detail.platform_key == 'dy'&&showBottomTag">
                  <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
                </ul> 
              </div>
              <!-- <ul v-if="detail.platform_key == 'new_media_knews'&&showMedia" class="tag first">
                  <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
              </ul>
              <ul v-if="detail.platform_key == 'dy'&&showMedia" class="tag first">
                  <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
              </ul> -->
              <div v-if="detail.platform_key != 'new_media_knews'&&detail.platform_key != 'dy'&&detail.platform_key != 'five_star_sports_cms'&&detail.platform_key != 'bilibili'&&showBottomTag" class="tagList">
                <ul>
                  <li>
                    <p>分类标签：</p>
                    <ul>
                      <li>{{detail.tag_lists && detail.tag_lists.tagName}}</li>
                    </ul>
                  </li>
                  <li>
                    <p>特色标签：</p>
                    <ul>
                      <li v-for="(item,index) in detail.tag_lists && detail.tag_lists.subTagName" :key="index">{{item}}</li>
                    </ul>
                  </li>
                  <li>
                    <p>自定义标签：</p>
                    <ul>
                      <li v-for="(item,index) in detail.tag_lists && detail.tag_lists.inputTags" :key="index">{{item}}</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="videoContent">
            <video v-show="detail.video_url" :src="detail.video_url" controls controlslist="nodownload"></video>
            <div v-if="detail.type == 5" class="articleContent" v-html="detail.info"></div>
            <div v-if="detail.type != 5" v-html="detail.content" class="writeContent"></div>
          </div> -->
        </div>
        
        <aside class="_xnsAside" v-show="!history_id">
          <div :class="{'aside-content': true, folded: !showMedia}">
            <p class="ptitle">
              <span>素材</span>
              <span class="right" @click="toggleMedia()">
                {{(detail.img_list && detail.img_list.length) + (detail.video_list && detail.video_list.length) + (detail.sound_list && detail.sound_list.length) + (detail.file_list && detail.file_list.length)}}
                <img :src="showMedia?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div class="nav" v-show="showMedia">
              <ul>
                <li :class="{active:navOn==0}" @click="navSwitch(0)">
                  图片
                  <span>{{detail.img_list && detail.img_list.length}}</span>
                </li>
                <li :class="{active:navOn==1}" @click="navSwitch(1)">
                  视频
                  <span>{{detail.video_list && detail.video_list.length}}</span>
                </li>
                <li :class="{active:navOn==2}" @click="navSwitch(2)">
                  音频
                  <span>{{detail.sound_list && detail.sound_list.length}}</span>
                </li>
                <!-- <li :class="{active:navOn==3}" @click="navSwitch(3)">文件 <span>{{detail.file_list && detail.file_list.length}}</span></li> -->
              </ul>
            </div>
            <div class="nav-content" v-show="showMedia">
              <div class="nav-item" v-if="navOn==0">
                <empty :msg="'暂无图片'" v-if="detail.img_list && detail.img_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.img_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.type}}</span>
                      </li>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.size}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>高度</p>
                        <span>{{img.content.pixel}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <img :src="img.cover || defaultImg" class="cover" alt="cover" />
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload && img.original_exists" class="down">
                      <span @click="downloadSource(img)"></span>
                    </li>
                  </ul>
                  <div v-if="quickEdit" class="btn add-qk append" @click="addQKFile(img, 'img')">
                    <button class="text add-qk">选用</button>
                  </div>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==1">
                <empty :msg="'暂无视频'" v-if="detail.video_list && detail.video_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.video_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.format}}</span>
                      </li>
                      <li>
                        <p>时长</p>
                        <span>{{img.content.duration}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.file_size}}</span>
                      </li>
                      <li>
                        <p>尺寸</p>
                        <span>{{img.content.resolution}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <div class='verify-success verify-item' v-if="img.has_audit&&img.has_audit==1">
                        <img alt="技审通过" title="技审通过" class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                      </div>

                      <div class='verify-fail verify-item' v-if="img.has_audit&&img.has_audit==2">
                        <img alt="技审未通过" title="技审未通过" class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                      </div>
                      <img :src="img.cover || defaultMedia" class="cover" alt="cover" />
                      <img src="@assets/img/common/play.svg" alt="play" class="play" />
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="detail.platform_key == 'new_media_knews' && ((img.original_exists && detail.has_high_quality_download_role) || detail.has_publish_quality_download_role)" class="down">
                      <span @click="toggleD(img,$event)">
                        <div class="dOptions" v-show="img.showD">
                          <p :class="{'disableD': !detail.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k" />
                            <i>800K码流</i>
                          </p>
                          <p v-if="img.original_exists && detail.platform_key != 'new_media_knews'" :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD" />
                            <i>原始码流</i>
                          </p>
                          <p v-if="img.original_exists && detail.platform_key == 'new_media_knews'" :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 2)">
                            <img src="@assets/img/common/HD.svg" alt="HD" />
                            <i>1080P</i>
                          </p>
                        </div>
                      </span>
                    </li>

                    <li v-if="showDownload && detail.platform_key != 'new_media_knews'" class="down">
                      <span @click="toggleD(img,$event)">
                        <div class="dOptions" v-show="img.showD">
                          <p :class="{'disableD': !detail.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k" />
                            <i>800K码流</i>
                          </p>
                          <p v-if="img.original_exists && detail.platform_key != 'new_media_knews'" :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD" />
                            <i>原始码流</i>
                          </p>
                          <p v-if="img.original_exists && detail.platform_key == 'new_media_knews'" :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 2)">
                            <img src="@assets/img/common/HD.svg" alt="HD" />
                            <i>1080P</i>
                          </p>
                        </div>
                      </span>
                    </li>
                  </ul>
                  <div class="btn">
                    <button v-if="quickEdit" class="text half add-qk" @click="addQKFile(img, 'video')">选用</button>
                    <div class="text" :class="{half:quickEdit}" @click="goInPicture(img)">
                      进入画中画
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==2">
                <empty :msg="'暂无音频'" v-if="detail.sound_list && detail.sound_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.sound_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.format}}</span>
                      </li>
                      <li>
                        <p>时长</p>
                        <span>{{img.content.duration}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.file_size}}</span>
                      </li>
                      <li>
                        <p>声道</p>
                        <span>{{img.content.track}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <img :src="img['content']?(img['content'].cover || defaultMedia):defaultMedia" class="cover" alt="cover" />
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload && img.original_exists" class="down">
                      <span @click="downloadSource(img, 1)"></span>
                      <!-- <span @click="toggleD(img,$event)">
                        <div class="dOptions" v-show="img.showD">
                          <p :class="{'disableD': !detail.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k" />
                            <i>800K码流</i>
                          </p>
                          <p :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD" />
                            <i>原始码流</i>
                          </p>
                        </div>
                      </span> -->
                    </li>
                  </ul>
                  <div v-if="quickEdit" class="btn add-qk append" @click="addQKFile(img, 'audio')">
                    <button class="text add-qk">选用</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div :class="{'aside-content': true, folded: !showMedia, first: true}">
            <p class="ptitle">
              <span>标签</span>
              <span class="right" @click="changeShowMedia">
                {{(detail.tags && detail.tags.length)}}
                <img :src="showMedia?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-if="detail && detail.tags && detail.tags.length > 0 && (detail.platform_key == 'new_media_knews' || detail.platform_key == 'dy')" class="tag first">
              <ul v-if="detail.platform_key == 'new_media_knews'&&showMedia">
                  <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
              </ul>

              <ul v-if="detail.platform_key == 'dy'&&showMedia">
                <li v-for="(item,index) in detail.tags" :key="index">{{item}}</li> 
              </ul> 
            </div>
            <div v-if="detail.platform_key != 'new_media_knews'&&detail.platform_key != 'dy'&&showMedia" class="tagList">
              <ul>
                <li>
                  <p>分类标签：</p>
                  <ul>
                    <li>{{detail.tag_lists && detail.tag_lists.tagName}}</li>
                  </ul>
                </li>
                <li>
                  <p>特色标签：</p>
                  <ul>
                    <li v-for="(item,index) in detail.tag_lists && detail.tag_lists.subTagName" :key="index">{{item}}</li>
                  </ul>
                </li>
                <li>
                  <p>自定义标签：</p>
                  <ul>
                    <li v-for="(item,index) in detail.tag_lists && detail.tag_lists.inputTags" :key="index">{{item}}</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="detail.platform_key == 'new_media_knews'" :class="{'aside-content mt20': true, folded: !showMedia1}">
            <p class="ptitle">
              <span>互动数据</span>
              <span class="right" @click="changeShowMedia1">
                <img :src="showMedia1?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <ul class="statistic-content" v-show="showMedia1">
              <li :class="{un: detail.knews_data && detail.knews_data.views && !detail.knews_data.views.available}">
                  <p>{{detail.knews_data && detail.knews_data.views && detail.knews_data.views.num}}</p>
                  <span>浏览量</span>
              </li>
              <li :class="{un: detail.knews_data && detail.knews_data.comments && !detail.knews_data.comments.available}">
                  <p>{{detail.knews_data && detail.knews_data.comments && detail.knews_data.comments.num}}</p>
                  <span>评论量</span>
              </li>
              <li :class="{un: detail.knews_data && detail.knews_data.shares && !detail.knews_data.shares.available}">
                  <p>{{detail.knews_data && detail.knews_data.shares && detail.knews_data.shares.num}}</p>
                  <span>分享链接</span>
              </li>
            </ul>
          </div> -->
          <div v-if="detail.platform_key == 'new_media_knews'" :class="{'aside-content mt20': true, folded: !showMedia2}">
            <p class="ptitle">
              <span>发布详情</span>
              <span class="right" @click="changeShowMedia2">
                <img :src="showMedia2?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-show="showMedia2" class="sendDetail">
              <ul>
                <li>
                  <div class="l">分发标题</div>
                  <div :title="detail.second_title" class="r">{{detail.second_title}}</div>
                </li>
                <!-- <li>
                  <div class="l">发布栏目</div>
                  <div :title="detail.column_name" class="r">{{detail.column_name}}</div>
                </li> -->
                <li>
                  <div class="l">记者</div>
                  <div :title="detail.reporter" class="r">{{detail.reporter}}</div>
                </li>
                <li>
                  <div class="l">来源</div>
                  <div :title="detail.from" class="r">{{detail.from}}</div>
                </li>
                <li>
                  <div class="l">编辑</div>
                  <div :title="detail.editor" class="r">{{detail.editor}}</div>
                </li>
                <li>
                  <div class="l">责编</div>
                  <div :title="detail.responsible_editor" class="r">{{detail.responsible_editor}}</div>
                </li>
                <li>
                  <div class="l">版权</div>
                  <div :title="detail.copyright" class="r">{{detail.copyright}}</div>
                </li>

                <li class="line"></li>

                <li v-if="detail && detail.video_editor">
                  <div class="l">视频编辑</div>
                  <div :title="detail.video_editor" class="r">{{detail.video_editor}}</div>
                </li>
                <li v-if="detail && detail.art_editor">
                  <div class="l">美术编辑</div>
                  <div :title="detail.art_editor" class="r">{{detail.art_editor}}</div>
                </li>
                <li v-if="detail && detail.cameraman">
                  <div class="l">摄像</div>
                  <div :title="detail.cameraman" class="r">{{detail.cameraman}}</div>
                </li>
                <li v-if="detail && detail.courier">
                  <div class="l">通讯员</div>
                  <div :title="detail.courier" class="r">{{detail.courier}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="detail.platform_key == 'five_star_sports_cms'" :class="{'aside-content mt20': true, folded: !showMedia2}">
            <p class="ptitle">
              <span>发布详情</span>
              <span class="right" @click="changeShowMedia2">
                <img :src="showMedia2?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-show="showMedia2" class="sendDetail">
              <ul>
                <li>
                  <div class="l">副标题</div>
                  <div :title="detail.second_title" class="r">{{detail.second_title}}</div>
                </li>
                <li>
                  <div class="l">来源</div>
                  <div :title="detail.from" class="r">{{detail.from}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="detail.platform_key == 'bilibili'" :class="{'aside-content mt20': true, folded: !showMedia2}">
            <p class="ptitle">
              <span>发布详情</span>
              <span class="right" @click="changeShowMedia2">
                <img :src="showMedia2?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-show="showMedia2" class="sendDetail">
              <ul>
                <li>
                  <div class="l">分区</div>
                  <div :title="detail.partition_name" class="r">{{detail.partition_name}}</div>
                </li>
                <li>
                  <div class="l">类型</div>
                  <div class="r">
                    <p>{{detail.b_type == 1 ? '转载' : '自制'}}</p>
                    <p v-show="detail.b_type == 1">{{detail.share_text}}</p>
                  </div>
                </li>
                <li>
                  <div class="l">允许转载</div>
                  <div class="r">{{detail.is_share == 1 ? '是' : '否'}}</div>
                </li>
              </ul>
            </div>
          </div>

          <!-- <div v-if="detail.platform_key == 'dy'" :class="{'aside-content mt20': true, folded: !showMedia1}">
            <p class="ptitle">
              <span>互动数据</span>
              <span class="right" @click="changeShowMedia1">
                <img :src="showMedia1?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div class="dyAnalysis">
              <div>
                <div :class="{un: detail.dy_data && detail.dy_data.likes && !detail.dy_data.likes.available}">
                  <p>{{detail.dy_data && detail.dy_data.likes && detail.dy_data.likes.num}}</p>
                  <span>点赞数</span>
                </div>
                <div :class="{un: detail.dy_data && detail.dy_data.comments && !detail.dy_data.comments.available}">
                  <p>{{detail.dy_data && detail.dy_data.comments && detail.dy_data.comments.num}}</p>
                  <span>评论数</span>
                </div>
              </div>
              <div>
                <div :class="{un: detail.dy_data && detail.dy_data.views && !detail.dy_data.views.available}">
                  <p>{{detail.dy_data && detail.dy_data.views && detail.dy_data.views.num}}</p>
                  <span>播放数</span>
                </div>
                <div :class="{un: detail.dy_data && detail.dy_data.shares && !detail.dy_data.shares.available}">
                  <p>{{detail.dy_data && detail.dy_data.shares && detail.dy_data.shares.num}}</p>
                  <span>分享数</span>
                </div>
              </div>
            </div>
          </div> -->
        </aside>
      </div>
      <div v-else class="playlistContent">
        <div class="left-container">
          <div class="media-container" :style="'width:'+ width +'px; height:'+ height +'px;'">
            <div v-show="detail.type-0 === 5" class="video">
              <video ref="videoDom" controls controlsList="nodownload" contextmenu="none" :src="detail.url"></video>
              <div class="speedRate">
                <div @click="showSelectList=!showSelectList" class="btn">
                  <span>{{nowSpeed}}</span>
                  <img src="@assets/img/material/whiteArrow.svg" alt="">
                </div>
                <div v-if="showSelectList" class="btnList">
                  <p></p>
                  <ul>
                    <li @click="changeSpeed('1x')">1x</li>
                    <li @click="changeSpeed('2x')">2x</li>
                    <li @click="changeSpeed('4x')">4x</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ref="imgDom" v-show="detail.type-0 === 7" :style="{'background-image': `url(${detail.url})`}" class="img"></div>
            <div v-show="detail.type-0 === 8" class="audio">
              <audio ref="audioDom" preload="load" :src="detail.url"></audio>
              <div :style="'width:'+logoWidth+'px; height:'+logoWidth+'px; margin-top:'+marginTop+'px;margin-bottom:'+marginBottom+'px'" class="control">
                <img :style="'width:'+logoWidth+'px; height:'+logoWidth+'px'" src="@assets/img/material/disk.png" alt="">
                <img @click="audioPlay" v-if="isPlay === false" class="play" src="@assets/img/material/playIcon.svg" alt="">
                <img @click="audioPause" v-if="isPlay" class="pause" src="@assets/img/material/pauseIcon.svg" alt="">
              </div>
              <div class="progress-container">
                <div class="time">
                  <span>{{nowTime}}</span>
                  <span class="grey">/{{endTime}}</span>
                </div>
                <div ref="line" class="progress">
                  <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                  <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                    <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                      @mousemove.prevent="slideMouseMove"></i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-container"> 
          <div class="detailContainer">
            <p class="ptitle">
              <span>详细信息</span>
              <span class="right" @click="showMaterial = !showMaterial">
                <img :src="showMaterial?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-show="showMaterial" class="detail">
              <div class="t">{{detail.title}}</div>
              <div class="c">
                <span>发布平台：</span>
                <p>{{detail.platform_title}}</p>
              </div>
              <div class="c">
                <span>发布人：</span>
                <p>{{detail.user_name}}</p>
              </div>
              <div class="c">
                <span>发布时间：</span>
                <p>{{detail.raw_update_time}}</p>
              </div>
            </div>
            <div v-show="showMaterial" class="line"></div>
            <div v-show="showMaterial" class="detail">
              <div v-show="detail.type == 5 || detail.type == 7" class="c">
                <span>分辨率：</span>
                <p>{{materialDetail.pixel}}</p>
              </div>
              <div class="c">
                <span>格式：</span>
                <p>{{materialDetail.format}}</p>
              </div>
              <div v-show="detail.type == 5 || detail.type == 7" class="c">
                <span>大小：</span>
                <p>{{materialDetail.file_size}}</p>
              </div>
              <div v-show="detail.type == 5" class="c">
                <span>帧率：</span>
                <p>{{materialDetail.fps}}</p>
              </div>
              <div v-show="detail.type == 5 || detail.type == 8" class="c">
                <span>时长：</span>
                <p>{{materialDetail.duration}}</p>
              </div>
              <div v-show="detail.type == 5 || detail.type == 8" class="c">
                <span>码率：</span>
                <p>{{materialDetail.rate}}</p>
              </div>
            </div>
          </div>

          <div class="detailContainer">
            <p class="ptitle">
              <span>发布详情</span>
              <span class="right" @click="showMaterial = !showMaterial">
                <img :src="!showMaterial?icons.up:icons.down" alt="icons" />
              </span>
            </p>
            <div v-show="!showMaterial" class="detail">
              <div class="c">
                <span>备注描述：</span>
                <p style="text-align: left !important;">{{detail.playlistRemark}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer v-if="!history_id">
        <li class="button white left">
          <button :class="{g: !reportLog, l: true}" @click="reportList">{{`稿件的一生`}}</button>
          <button v-if="detail.has_pass" @click="upload(detail)" :class="{b: true, gr: detail.is_lock}">通过</button>
          <button v-if="detail.has_reject" @click="sendBack(detail.id)" :class="{r: true, gr: detail.is_lock}">退回</button>
          <button v-if="detail.has_copy" @click="copyMedia" class="b">转发</button>
          <button v-if="detail.has_view && detail.status != 4 && detail.status != 5 && !isCheck" @click="viewMedia" class="b">预览</button>
          <button v-if="detail.has_resend" @click="resend" class="r">重新发布</button>
          <div v-click-outside="closeDownloadBox" class="newDownloadBox">
            <div v-show="showDownloadBtn" class="btn">
              <ul>
                <li @click="downloadSource(materialDownload, 0);showDownloadBtn = false">
                  <img src="@assets/img/common/800k.svg" alt="800k" />
                  <i>800K码流</i>
                </li>
                <li @click="downloadSource(materialDownload, 1);showDownloadBtn = false">
                  <img src="@assets/img/common/HD.svg" alt="HD" />
                  <i>原始码流</i>
                </li>
              </ul>
            </div>
            <button v-if="detail.platform_key == 'playlist' && detail.type == 5" @click="showDownloadBtn = !showDownloadBtn" class="w">下载</button>
          </div>
          <button v-if="detail.platform_key == 'playlist' && detail.type != 5" @click="downloadSource(materialDownload, 1)" class="w">下载</button>
          <button v-if="detail.has_download && detail.platform_key != 'playlist'" @click="downloadArticle" class="w">下载文稿</button>
          <button v-if="detail.has_share && detail.status == 1 && detail.status != 5" @click="share" class="w">分享链接</button>
          <div v-click-outside="closeShowDetailTool" v-if="(detail.has_view && detail.status != 1 && detail.platform_key != 'five_star_sports_cms') || (isCheck && detail.platform_key != 'five_star_sports_cms') || (detail.has_view && detail.status != 1 && detail.platform_key == 'five_star_sports_cms' && detail.type == 6) || detail.has_share && detail.status != 1 || detail.has_stream_send || detail.has_cancel || (detail.has_edit && !detail.is_lock)" class="more-container">
            <div title="更多" @click="showDetailTool = !showDetailTool" :class="{more: true, on: showDetailTool}"></div>
            <div v-if="showDetailTool" class="btn">
              <ul>
                <li v-if="(detail.has_view && detail.status != 1 && detail.platform_key != 'five_star_sports_cms' && detail.platform_key != 'playList') || (isCheck && detail.platform_key != 'five_star_sports_cms' && detail.platform_key != 'playList') || (detail.has_view && detail.status != 1 && detail.platform_key == 'five_star_sports_cms' && detail.type == 6 && detail.platform_key != 'playList')" @click="viewMedia();showDetailTool = false;">预览</li>
                <li v-if="detail.has_share && detail.status != 1" @click="share();showDetailTool = false;">分享链接</li>
                <li v-if="detail.has_stream_send" @click="mediaSend(detail.id);showDetailTool = false;">归档</li>
                <li v-if="detail.has_cancel" @click="showDetailTool = false;showTipsContent = true">撤回</li>
                <li v-if="detail.has_edit && !detail.is_lock" @click="goEdit(detail.id);showDetailTool = false;">编辑</li>
              </ul>
              <span></span>
            </div>
          </div>
        </li>
        <div class="right button"></div>
        <!-- 报道一生 -->
        <div class="reportList" v-if="reportLog && life.length > 0">
          <ul class="stages">
            <div class="progress" :style="{height: `${progressH}px`}"></div>
            <li v-for="(l, i) in life" :key="i">
              <label :class="{current: i === 0}">{{l.action}}</label>
              <p>
                <span class="time">{{l.raw_add_time}}</span>
                <span class="name">{{l.opt_username}}</span>
                <span :class="{time: true, success: l.action_color == 1, return: l.action_color == 2}">{{l.type}}</span>
              </p>
            </li>
          </ul>
        </div>
      </footer>
    </div>
    <pushBox ref="pushBox" />
    <successTip ref="successTip" />
    <rebindTip ref="rebindTip" />
    <div v-if="showProceed" class="noticeBox">
        <i class="success"></i>
        <p>正在发布中…</p>
    </div>
    <div v-show="showTipsContent" class="tips-container">
        <div class="bg"></div>
        <div class="tips-content">
            <p class="title">温馨提示</p>
            <div class="Knews">撤回后稿件内容需要重新提交审核，是否继续？</div>
            <div class="btns">
                <p @click="showTipsContent = false;newMediaCancel();" class="green">确定</p>
                <p @click="showTipsContent = false;">取消</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import dc from "@common/dc";
import empty from "@components/empty";
import pushBox from "@components/pushBox";
import notice from "@components/notice";
import successTip from "@components/successTip";
import rebindTip from "@components/rebindTip";
import vClickOutside from "v-click-outside";
import Vue from "vue";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    headline,
    empty,
    pushBox,
    notice,
    successTip,
    rebindTip
  },
  watch: {
    "$store.state.flashPic1": function (el) {
      if (el) {
        this.getData();
        this.$store.commit("setflashPic1", false);
      }
    },
    $route(to, from) {
      this.getPageVersion();
    }
  },
  data() {
    return {
      width: 696,
      height: 392,
      showTipsContent: false,
      showBottomTag: true,
      canInterview: true,
      autoLockInterval: null,
      showDetailTool: false,
      showProceed: false,
      showError: true,
      visit_log: 0,
      visit_log_list: [],
      isXnew: this.$store.state.isXnew,
      headLines: {
        title: "",
        showLink: false,
        filter: false
      },
      icons: {
        up: require("@assets/img/common/upward.svg"),
        down: require("@assets/img/common/xiala.svg"),
        upGreen: require("@assets/img/common/upward_green.svg"),
        downGreen: require("@assets/img/common/downward_green.svg")
      },
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/defaultMedia.png"),
      defaultAudio: require("@assets/img/common/defaultAudio.png"),
      showMedia: true,
      showMedia1: false,
      showMedia2: false,
      detail: {},
      navOn: 0,
      isDialog: false,
      fileType: false,
      reportLog: false,
      report_id: null,
      life: [],
      showVersions: false,
      history: [],
      history_id: "",
      speed: 0,
      bodyText: "", // 正文纯文字
      headText: "", // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0, // 导语时长
      isCheck: false,
      showDownload: false,
      content: "",
      showExtendInfo: false,
      progressH: 0,
      isEmpty: false,
      showView: false,
      noStyleWord: '',
      noStyleDuration: 0,
      errMessage: '',
      nowSpeed: '1x',
      nowTime: "00:00:00",
      endTime: "00:00:00",
      duration: 0,
      percent: 0,
      audioPercent: "0%",
      isMouseClick: false,
      showSelectList: false,
      isPlay: false,
      logoWidth: 212,
      iconWidth: 36,
      iconMargin: 30,
      marginBottom: 0,
      marginTop: 0,
      materialDetail: {
        pixel: ''
      },
      showMaterial: true,
      isInit: false,
      showDownloadBtn: false,
      materialDownload: {}
    };
  },
  computed: {
    quickEdit() {
      return this.$store.state.quickEdit;
    }
  },
  methods: {
    getBiliPartition(column_key, id) {
      let info = {
          column_key: column_key
      }
      common
      .myFetch(apis.getBiliPartition, info)
      .then(r => {
          if (r) {
              r.data.forEach(el => {
                if(el.children && el.children.length > 0){
                  el.children.forEach(el1 => {
                    if(el1.id == id){
                      this.detail.partition_name = el1.name
                    }
                  })
                }
              })
          }
      });
    },
    changeShowMedia() {
      if(this.showMedia){
        this.showMedia = false
        this.showMedia1 = true
        this.showMedia2 = false
      }else{
        this.showMedia = true
        this.showMedia1 = false
        this.showMedia2 = false
      }
    },
    changeShowMedia1() {
      if(this.showMedia1){
        this.showMedia = true
        this.showMedia1 = false
        this.showMedia2 = false
      }else{
        this.showMedia = false
        this.showMedia1 = true
        this.showMedia2 = false
      }
    },
    changeShowMedia2() {
      if(this.showMedia2){
        this.showMedia = true
        this.showMedia1 = false
        this.showMedia2 = false
      }else{
        this.showMedia = false
        this.showMedia1 = false
        this.showMedia2 = true
      }
    },
    mediaSend(id) {
      let info = {
          subject_type: 5,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    //通过
    upload(detail) {
      if(this.canInterview){
        if(detail.is_last_audit == 1 && detail.platform_key == 'dy' && detail.has_dy_btn == 0){
          let info = {
            id: detail.id
          }

          common
          .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
          .then(r => {
            if(r){
              if(r.data.length > 0){
                if(r.data[0].type == 'locked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else if(r.data[0].type == 'authLocked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else{
                  this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
                }
              }else{
                this.$ConfirmDy({title: detail.title,column: detail.platform_title}).then(res => {
                  if(res){
                    let lockInfo = {
                      id: detail.id
                    }

                    common
                    .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                    .then(r => {
                        if (r) {
                          let content = [{
                            id: detail.id
                          }]

                          content = JSON.stringify(content)

                          const info = {
                            content: content,
                            status: 0
                          };

                          common.myFetch(apis.newMediaVerify, info).then(data => {
                            if (data) {
                              if(data.length > 0){
                                data[0].showIcon = false;
                                data[0].title = '温馨提示';
                                data[0].btn1 = '确定'
                                this.$MediaPlatformNotifyAuth(data[0])
                                this.canInterview = true
                              }else{
                                this.canInterview = false
                                const successInfo = {
                                    msg: "稿件通过",
                                    tip: "页面即将关闭"
                                };

                                this.$refs.successTip.open(successInfo);
                              }
                            }
                          });
                        }
                    });
                  }
                })
              }
            }
          })
        }else if(detail.is_last_audit == 1 && detail.platform_key != 'dy'){
          let info = {
            id: detail.id
          }

          common
          .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
          .then(r => {
            if(r){
              if(r.data.length > 0){
                if(r.data[0].type == 'locked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else if(r.data[0].type == 'authLocked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else{
                  this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
                }
              }else{
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '<span>'+detail.title+'</span>'+'将被推送至'+'<span>'+detail.platform_title+'</span>', content2: '', btn1: '确定通过', btn2: '取消'}).then(res => {
                  if(res){
                    let lockInfo = {
                      id: detail.id
                    }

                    common
                    .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                    .then(r => {
                        if (r) {
                          let content = [{
                            id: detail.id
                          }]

                          content = JSON.stringify(content)

                          const info = {
                            content: content,
                            status: 0
                          };

                          common.myFetch(apis.newMediaVerify, info).then(data => {
                            if (data) {
                              if(data.length > 0){
                                data[0].showIcon = false;
                                data[0].title = '温馨提示';
                                data[0].btn1 = '确定'
                                this.$MediaPlatformNotifyAuth(data[0])
                                this.canInterview = true
                              }else{
                                this.canInterview = false
                                const successInfo = {
                                    msg: "稿件通过",
                                    tip: "页面即将关闭"
                                };

                                this.$refs.successTip.open(successInfo);
                              }
                            }
                          });
                        }
                    });
                  }
                })
              }
            }
          })
        }else{
          this.handleInterview(detail.id, 0);
        }
      }
    },
    //退回
    sendBack(id) {
      if(this.canInterview){
        this.handleInterview(id, 1);
      }
    },
    async handleInterview(id, status) {
      let info = {
        id: id
      }

      common
      .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
      .then(async r => {
        if(r){
          if(r.data.length > 0){
            if(r.data[0].type == 'locked'){
              r.data[0].showIcon = false;
              r.data[0].title = '温馨提示';
              r.data[0].btn1 = '确定'
              this.$MediaPlatformNotifyAuth(r.data[0])
            }else if(r.data[0].type == 'authLocked'){
              r.data[0].showIcon = false;
              r.data[0].title = '温馨提示';
              r.data[0].btn1 = '确定'
              this.$MediaPlatformNotifyAuth(r.data[0])
            }else{
              this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
            }
          }else{
            if(this.detail.is_lock) return
            let msg = "确认通过吗？";
            let remark = "";
            if (status === 1) {
              msg = "确认退回吗？";
            }
            const c = await this.$confirm(msg);
            if (!c) return;
            this.canInterview = false
            if(status === 1) {
              const statusInfo = {
                id: id
              };
              common.myFetch(apis.newMediaCheckstatus, statusInfo).then(data => {
                if(data){
                  console.log(data)
                  if(data.unavailable.length > 0){
                    data.unavailable[0].showIcon = false;
                    data.unavailable[0].title = '温馨提示';
                    data.unavailable[0].btn1 = '确定'
                    this.$MediaPlatformNotifyAuth(data.unavailable[0])
                    this.canInterview = true
                  }else{
                    this.$Dialog({}).then((e) => {
                      console.log(e)
                      if(e){
                        let content = [{
                          id: id,
                          remark: e
                        }]

                        const info = {
                          status: 1,
                          content: JSON.stringify(content)
                        }

                        common.myFetch(apis.newMediaVerify, info).then(data => {
                          if (data) {
                            this.canInterview = false
                            const successInfo = {
                                msg: "稿件退回",
                                tip: "页面即将关闭"
                            };

                            this.$refs.successTip.open(successInfo);
                          }
                        });
                      }
                    })
                  }
                }
              })
            }else{
              let lockInfo = {
                id: id
              }

              common
              .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
              .then(r => {
                  if (r) {
                    let content = [{
                      id: id
                    }]

                    content = JSON.stringify(content)

                    const info = {
                      content: content,
                      status: status
                    };

                    common.myFetch(apis.newMediaVerify, info).then(data => {
                      if (data) {
                        if(data.length > 0){
                          data[0].showIcon = false;
                          data[0].title = '温馨提示';
                          data[0].btn1 = '确定'
                          this.$MediaPlatformNotifyAuth(data[0])
                          this.canInterview = true
                        }else{
                          this.canInterview = false
                          const successInfo = {
                              msg: "稿件通过",
                              tip: "页面即将关闭"
                          };

                          this.$refs.successTip.open(successInfo);
                        }
                      }
                    });
                  }
              });
            }
          }
        }
      })
    },
    async newMediaCancel() {
      // let confirm = {};

      
      // let msg = `撤回该发布？`;

      // confirm.status = await this.$confirm(msg);
      // confirm.isSelected = 0;
        
      // if (!confirm.status) return;

      let info = {
        id: this.detail.id
      }

      common.myFetch(apis.newMediaCancel, info).then(r => {
        if (r) {
          this.$toast(r)
          setTimeout(() => {
            window.close()
          }, 2000);
        }
      });
    },
    closeShowDetailTool() {
      this.showDetailTool = false;
    },
    downloadArticle() {
      const info = {
        id: this.detail.id
      };

      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)

      common.exportRes(apis.newMediaDownload, params)

      // common.myFetch(apis.newMediaDownload, info).then(r => {
      //   if (r) {
      //     console.log(r)
      //   }
      // });
    },
    reS() {
      this.$BPlus(this.detail.platform_key).then(res => {
        if(res) {
          this.getData();
        }
      }) 
    },
    share() {
      this.$MediaPlatformShare(this.detail.id)
    },
    resend() {
      const info = {
        id: this.detail.id
      };

      common.myFetch(apis.newMediaPlatformMyResend, info).then(r => {
        if (r) {
          if(r == '操作成功'){
            const successInfo = {
              msg: "发布成功",
              type: "ok"
            };

            this.$refs.rebindTip.open(successInfo);
          }else{
            const successInfo = {
              msg: "发布失败",
              type: "error"
            };

            this.$refs.rebindTip.open(successInfo);
          }
        }else{
          const successInfo = {
              msg: "发布失败",
              type: "error"
            };

          this.$refs.rebindTip.open(successInfo);
        }
      });
    },
    toggleView() {
      this.showView = !this.showView;
    },
    addQKFile({ id }, type) {
      console.log("addQKFile  file id", id);
      console.log("addQKFile type", type);
      let data = {
        file_ids: id
      };
      common.myFetch(apis.File_addquickfile, data).then(res => {
        console.log("File_addquickfile res", res);
        if (res) {
          this.$toast("已成功加入选用素材");
        }
      });
    },
    zoomIn(e) {
      console.log('zoomin')
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.add("zoom");
      mask.classList.add("show");
    },
    zoomOut(e) {
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.remove("zoom");
      mask.classList.remove("show");
    },
    showWarning() {
      // 唤起警示窗口
      const content = {
        id: this.$route.query.d,
        type: 1,
        msg: this.detail.warning_content
      };

      this.$warning(content).then(r => {
        if (r) {
          this.getData();
        }
      });
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    showCard1(id, e) {
      if (id == 0) return;

      const el = e.target;

      console.log(e)

      this.$cardPos(id, e);
    },
    toggleExtendor() {
      this.showExtendInfo = !this.showExtendInfo;
    },
    goInPicture(item) {
      if (!item.content || item.content.status != 1) {
        this.$toast("转码中，暂时无法进入画中画");
        return;
      }

      this.$miniPicture(item.url);
    },
    async copyMedia() {
      // 转发发布
      const id = this.$route.query.d;
      const type = await this.$MediaPlatform('copy');

      if (!type) return;

      const info = {
        id: id,
        platforms: type
      };
      const newWindow = window.open();

      common.myFetch(apis.newMediaPlatformMyCopy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/editMediaPublish?d=${r.report_id}`;
        }
      });
    },
    viewMedia() {
      if(this.detail.platform_key == 'new_media_knews' || this.detail.platform_key == 'five_star_sports_cms'){
        this.$PreviewKnews(this.detail.id)
      }else if(this.detail.platform_key == 'bilibili'){
        this.$PreviewBili(this.detail.id)
      }else{
        this.detail.platformType = this.detail.platform_key
        this.$PreviewBox(this.detail)
      }
    },
    hoverFailBtn(item, status) {
      // 转码失败按钮鼠标事件
      this.$set(item, "hover", status);
    },
    toggleD(i, e) {
      const el = e.target
      let query = this.$route.query.d;
      this.$DownloadBtn(5, query, this.detail, i, el)
      // this.$set(i, "showD", !i.showD);
    },
    async goEdit(id) {
      const checked = await common.checkPageStatus(id, 2);
      if (!checked) return;

      common.jump(`/editMediaPublish?d=${id}`, false);
    },
    checkType() {
      // 检查页面类型：详情 ／ 审核详情
      console.log(this.detail)
      const c = this.$route.query.c;
      if (c) {
        this.isCheck = true;
        this.headLines.title = `${this.$_syscfg.publish}审核`;
      } else {
        this.headLines.title = `${this.$_syscfg.publish}详情`;
      }
    },
    async handleReport(status) {
      // 审核／退回发布
      let msg = `确定通过${this.$_syscfg.publish}吗？`;
      if (status === 1) {
        msg = `确定退回${this.$_syscfg.publish}吗? `;
      }
      const confirm = await this.$confirm(msg);
      if (!confirm) return;

      const id = this.$route.query.d;
      let info = {
        id: id,
        status: status
      };

      common.myFetch(apis.publishVerify, info).then(res => {
        if (res) {
          this.$toast(res);

          window.close();
        }
      });
    },
    goClueDetail(id) {
      // 跳转线索详情
      if (!this.detail.has_material_detail_role) return;

      common.jump(`/clueDetail?d=${id}`, true);
    },
    goTopic() {
      if (this.detail.st_is_delete == 1 || !this.detail.has_topic_role) return;

      this.$router.push({
        path: "/topicDetail",
        query: {
          d: this.detail.st_id
        }
      });
    },
    goItv() {
      if (!this.detail.has_interview_role) return;

      this.$router.push({
        path: "/interviewDetail",
        query: {
          r: this.detail.iview_id
        }
      });
    },
    watchContent(c) {
      // 检测内容变化
      if(this.detail.type == 0){
        this.noStyleWord = this.detail.html_content
      }else{
        const bodyText = common.getBody(c);
        const headText = common.getLead(c);

        this.bodyText = common.replacePunctuations(bodyText);
        this.headText = common.replacePunctuations(headText);
      }
      this.calculateText();
    },
    calculateText() {
      // 计算时长
      const gap = 60 / this.speed;
      if(this.detail.type == 0){
        this.noStyleDuration = gap * this.noStyleWord.length;
      }else{
        this.bodyDurantion = gap * this.bodyText.length;
        this.headDurantion = gap * this.headText.length;
      }
    },
    goTags(i) {
      // 跳转自采线索并选中标签
      this.$router.push({
        name: "publishLibrary",
        params: {
          tag: i.title
        }
      });
    },
    goViewer(data, item) {
      if (!item.trans_finish) {
        this.$toast("转码中，暂时无法预览");
        return;
      }
      let config = {
        type: item.type,
        id: item.id,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: true,
        t: Number(2),
        d: this.$route.query.d,
        isDetailComplete: true
      };
      console.log("config", config);
      let list = [
        ...data.img_list,
        ...data.video_list.filter(e => e.content.status == 1),
        ...data.sound_list.filter(e => e.content.status == 1)
      ];
      // list 有id即可
      let index = list.findIndex(e => e.id == item.id);
      this.$materialBox(config, this.getData, {
        index,
        list,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: false,
        t: Number(2),
        d: this.$route.query.d,
        isDetailComplete: true
      });
    },
    goViewer1(data, item) {
      if (item.type != 1 && (!item.content || item.content.status != 1)) {
        this.$toast("转码中，暂时无法预览");
        return;
      }

      const now = {
        url: item.url,
        type: item.type - 0,
        downloadUrl: item.download_url
      };

      common.viewMedia(data, now);
    },
    getMedias() {
      // 获取内部媒体：图片／视频，并使用浏览器打开
      const content = document.getElementById("content");
      const imgs = content.getElementsByTagName("img");
      const videos = content.getElementsByTagName("video");
      const imglist = Array.from(imgs).map(i => i.src);

      for (let i of imgs) {
        i.addEventListener("click", () => {
          this.openViewer(imglist, i.src, "img");
        });
      }

      for (let v of videos) {
        v.addEventListener("click", () => {
          this.openViewer(
            videos,
            { url: i.src, downloadUrl: i.src, idstring: "" },
            "video"
          );
        });
      }
    },
    openViewer(list, src, type) {
      this.$viewer(list, src, type);
    },
    chooseVersion(i) {
      // 选择历史版本
      const info = {
        history_id: i.history_id
      }

      common.myFetch(apis.publish_historydetail, info)
        .then(r => {
          if (r) {
            this.detail = r.detail
            this.history_id = r.detail.history_id

            this.speed = this.detail.content_speed || 0
            let content = this.detail.content
            if (this.detail.type == 0 || this.detail.type == 3) {
              content = common.replaceN2Br(content)
            }
            this.content = content
            this.watchContent(this.detail.content)

            this.$nextTick(() => {
              common.formatXNSAudios()
              common.handlePageMediaCenterPosition()
              let video = document.querySelectorAll('#content video')
              for (let index = 0; index < video.length; index++) {
                video[index].style.display = 'flex'
                video[index].style.margin = '0 auto'
                video[index].style.maxWidth = '80%'
              }
              let img = document.querySelectorAll('#content img')
              for (let index = 0; index < img.length; index++) {
                img[index].style.display = 'flex'
                img[index].style.margin = '0 auto'
                img[index].style.maxWidth = '80%'
              }
              let audio = document.querySelectorAll('#content audio')
              for (let index = 0; index < audio.length; index++) {
                audio[index].style.display = 'flex'
                audio[index].style.margin = '0 auto'
                audio[index].style.maxWidth = '80%'
              }
              let iframe = document.querySelectorAll('#content iframe')
              for (let index = 0; index < iframe.length; index++) {
                iframe[index].style.display = 'flex'
                iframe[index].style.margin = '0 auto'
                iframe[index].style.maxWidth = '80%'
                iframe[index].style.boxShadow = '4px 4px 10px 0 rgba(5,10,15,0.05)'
              }
            })
          }
        })

      this.showVersions = false;

      this.$router.push({
        path: "/publishDetail",
        query: {
          d: this.$route.query.d,
          h: i.history_id
        }
      });
    },
    toVersion(info) {
      // 获取特定版本数据并渲染
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.publish_historydetail, info).then(r => {
        if (r) {
          this.detail = r.detail;
          this.history_id = r.detail.history_id;

          this.speed = this.detail.content_speed || 0;
          let content = this.detail.content;
          if(content == ''){
            this.isEmpty = true
          }
          if (this.detail.type == 0 || this.detail.type == 3) {
            content = common.replaceN2Br(content);
            content = content || emptyPage;
          }
          this.content = content;
          this.watchContent(this.detail.content);

          this.$nextTick(() => {
            common.formatXNSAudios();
            common.handlePageMediaCenterPosition();
            let video = document.querySelectorAll('#content video')
            for (let index = 0; index < video.length; index++) {
              video[index].style.display = 'flex'
              video[index].style.margin = '0 auto'
              video[index].style.maxWidth = '80%'
            }
            let img = document.querySelectorAll('#content img')
            for (let index = 0; index < img.length; index++) {
              img[index].style.display = 'flex'
              img[index].style.margin = '0 auto'
              img[index].style.maxWidth = '80%'
            }
            let audio = document.querySelectorAll('#content audio')
            for (let index = 0; index < audio.length; index++) {
              audio[index].style.display = 'flex'
              audio[index].style.margin = '0 auto'
              audio[index].style.maxWidth = '80%'
            }
            let iframe = document.querySelectorAll('#content iframe')
            for (let index = 0; index < iframe.length; index++) {
              iframe[index].style.display = 'flex'
              iframe[index].style.margin = '0 auto'
              iframe[index].style.maxWidth = '80%'
              iframe[index].style.boxShadow = '4px 4px 10px 0 rgba(5,10,15,0.05)'
            }
          });
        }
      });
    },
    toggleVersions() {
      this.showVersions = !this.showVersions;
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.detail.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.content.status != 1) {
            this.$toast("转码尚未完成");
            return;
          }
        }
      } else if (type === 1) {
        if(source.type == 3){
          if (!this.detail.has_high_quality_download_role && !this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detail.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      } else if (type === 2) {
        if(source.type == 3){
          if (!this.detail.has_high_quality_download_role && !this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detail.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0,
        subject_type: 5,
        subject_id: this.$route.query.d
      };
      const url = apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    goWord(idstring, type) {
      let url = `/videotoword?d=${idstring}`;
      if (type === "audio") {
        url = `/audiotoword?d=${idstring}`;
      }

      common.jump(url, true);
    },
    convertWord(f) {
      // 音视频转文字
      if (!f.content || f.content.status != 1) {
        this.$toast("转码中，暂时无法转文字");
        return;
      }

      const info = {
        idstring: f.idstring
      };

      common.myFetch(apis.File_convert, info).then(r => {
        if (r) {
          this.$toast(r);

          this.$set(f, "text_status", 2);
        }
      });
    },
    download() {
      const info = {
        id: this.$route.query.d
      };

      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);
      const url = apis.down_publish;

      common.exportRes(url, params);
    },
    async pushKK() {
      const id = this.$route.query.d;
      // const config = {
      //   msg: "是否添加knews套件？",
      //   alpha: {
      //     title: "添加",
      //     handle: () => {
      //       this.postKK(id, 1);
      //     }
      //   },
      //   beta: {
      //     title: "不添加",
      //     handle: () => {
      //       this.postKK(id, 0);
      //     }
      //   }
      // };

      // this.$ask(config);

      const config = {
        id: id
      }

      this.$kkType(config).then((res) => {
        if(res!=999){
          this.postKK(id, res)
        }
      })
    },
    postKK: (id, type) => {
      const info = {
        id: id,
        three: type
      };

      common.myFetch(apis.toKK, info).then(r => {
        if (r) {
          Vue.prototype.$toast(r);
        }
      });
    },
    pushTo() {
      const id = this.$route.query.d;

      this.$refs.pushBox.open(id);
    },
    toggleMedia() {
      // this.showMedia = !this.showMedia;

      if(this.showMedia){
        this.showMedia = false
        this.showMedia2 = true
      }else{
        this.showMedia = true
        this.showMedia2 = false
      }
    },
    // 报道跳转
    goReport(id) {
      common.jump(`/reportDetail?d=${id}`, true);
    },
    navSwitch(n) {
      this.navOn = n;
      // this.getData()
    },
    dialog() {
      this.isDialog = !this.isDialog;
    },
    reportList() {
      this.reportLog = !this.reportLog;

      if (this.reportLog) {
        this.$nextTick(() => {
          const container = document.querySelector(".stages");
          const stagesHeight = container.scrollHeight;
          this.progressH = stagesHeight;
        });
      }
    },
    getData() {
      const id = this.$route.query.d;
      const info = {
        id: id,
        from: this.isCheck ? 'verify' : ''
      };
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.newMediaPlatformMyDetail, info).then(res => {
        if (res) {
          
          this.detail = res.detail;
          this.life = res.detail.history
          if(this.detail.platform_key == 'bilibili') {
            this.getBiliPartition(res.detail.column_key,res.detail.partition_id)
          }
          this.showDownload =
            this.detail.has_high_quality_download_role ||
            this.detail.has_low_quality_download_role;
          if(this.detail.status != 1){
            console.log(123)
            this.isCheck = false;
            this.headLines.title = `${this.$_syscfg.publish}详情`;
          }
          if(this.detail.is_publish == 1){
            if(this.detail.is_online == 0){
              this.detail.status_name = '未上线'
            }else{
              this.detail.status_name = '已上线'
            }
          }
          if(this.detail.type == 5){
            this.materialDetail = this.detail.video_list[0].content
            this.detail.url = this.detail.video_list[0].url
            this.materialDownload = this.detail.video_list[0]
          }else if(this.detail.type == 7){
            this.materialDetail = this.detail.img_list[0].content
            this.detail.url = this.detail.img_list[0].url
            this.materialDownload = this.detail.img_list[0]
          }else if(this.detail.type == 8){
            this.materialDetail = this.detail.sound_list[0].content
            this.detail.url = this.detail.sound_list[0].url
            this.materialDownload = this.detail.sound_list[0]

            setTimeout(() => {
              this.audioLoad()
            }, 500);
          }
          console.log(this.detail)
          if(this.detail.is_lock){
            let data = {
              showIcon: false,
              title: '温馨提示',
              btn1: '确定',
              msg: this.detail.lock_username,
              uid: this.detail.lock_uid,
              type: 'locked'
            }
            this.$MediaPlatformNotifyAuth(data).then(e => {
              if(e){
                // window.close()
              }
            })
          }

          if(this.detail.status == 4){
            this.errMessage = `${this.detail.platform_title} 推送失败，请联系系统管理员`
          }

          this.isInit = true
        }
      });
    },
    getRptLife() {
      // 获取报道的一生
      const id = this.$route.query.d;
      const info = {
        id: id
      };

      common.myFetch(apis.newMediaPlatformMyHistory, info).then(res => {
        if (res) {
          this.life = res.list;
        }
      });
    },
    getVersions() {
      // 获取历史版本号
      const id = this.$route.query.d;
      const info = {
        id: id,
        page: 1,
        pagesize: 50
      };

      common.myFetch(apis.publish_history, info).then(r => {
        if (r) {
          this.history = r.list;
        }
      });
    },
    handleAutoLock() {
        let info = {
            id: this.$route.query.d
        }

        common
        .myFetch(apis.newMediaLock, {data: info,hideLoading: true})
        .then(r => {
            if (r) {
                // this.showSaveTip()
            }
        });
    },
    setAutoLock() {
        this.autoLockInterval = this.autoLockInterval || setInterval(() => {
            this.handleAutoLock()
        }, 30000);
    },
    getTranstext(r) {
      // 获取转文字状态
      this.$toast("转文字完成");
      this.getData();
    },
    getTranscode(r) {
      // 获取转码通知
      const info = r.content;
      if (info) {
        this.$toast(`${info.title}已入库`);
        this.getData();
      }
    },
    getPageVersion() {
      // 根据url参数选择渲染当前或历史版本
      const h = this.$route.query.h;
      if (h) {
        const info = {
          history_id: h
        };

        this.toVersion(info);
      } else {
        this.history_id = null;

        this.getData();
      }
    },
    //预览
    async goPublish(i) {
      if (!i) return
      await this.$audit(i)
    },
    showCloseTips(content) {
      // console.log(content)
      let params = JSON.parse(content.content)
      let status = false;
      if(params.child_list.length > 0){
          params.child_list.forEach(el => {
            if((el.id == this.$route.query.d)){
              status = true
            }         
          })
      }

      // this.mediaPublishDetail.platforms.forEach(el => {
      //     el.list.forEach(items => {
      //         if(items.id == this.articleId){
      //             this.$auditDialog({type: 'notice', title: '溫馨提示', content1: '当前稿件已发布', content2: '', btn1: '确定', btn2: ''}).then(res => {

      //             })
      //         }
      //     })
      // })
      
      if(status){
          this.$auditDialog({type: 'notice', title: '温馨提示', content1: params.title, content2: '', btn1: '确定', btn2: ''}).then(res => {
              if(res){
                  window.location.reload()
              }
          })
      }

    },
    disableContextMenu() {
      // 隐藏右键菜单
      if(this.$refs.videoDom){
        this.$refs.videoDom.oncontextmenu = function(event) {
          return false
        }
      }
    },
    recalc() {
      let clientHeight = document.documentElement.clientHeight;

      if(!clientHeight){
        return ;
      }

      let p = 100 * (clientHeight / 1334);

      if(p<100){
        p=100
      }

      this.width = 6.96*p;
      this.height = 3.92*p

      this.logoWidth = 2.12*p

      this.marginTop = (this.height -this.logoWidth)/2
      this.marginBottom = 0.24*p
      this.iconWidth = 0.36*p
      this.iconMargin = 0.3*p
    },
    audioPlay(){
      this.$refs.audioDom.play();
      this.isPlay=true;
    },
    audioPause(){
      this.$refs.audioDom.pause();
      this.isPlay=false;
    },
    clickJump(e) {
      let clientX = this.$refs.line.getBoundingClientRect().x;
      let width = this.$refs.line.getBoundingClientRect().width;
      let left = 0;
      let percent = 0;

      if (e.clientX - clientX <= 0) {
        left = "0%";
      } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
        left = "100%";
      } else {
        percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
        left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
      }

      this.percent = percent;
      this.audioPercent = left;

      // this.$refs.sliderLeft.style.width = left;

      this.timeNavi();

      this.isMouseClick = false;
    },
    timeNavi() {
      if (this.isMouseClick) {
        let percent = this.percent / 100;
        let time = (percent * this.duration).toFixed(2);
        this.$refs.audioDom.currentTime = time;
        this.$refs.audioDom.play();
        this.isPlay = true;
        this.isMouseClick = false;
      }
    },
    timeStop() {
      this.isPlay = false;
      this.$refs.audioDom.pause();
    },
    slideMouseMove(e) {
      // return false;
      if (this.isMouseClick) {
        let clientX = this.$refs.line.getBoundingClientRect().x;
        let width = this.$refs.line.getBoundingClientRect().width;
        let left = 0;
        let percent = 0;

        if (e.clientX - clientX <= 0) {
          left = "0%";
        } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
          left = "100%";
        } else {
          percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
          left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
        }

        this.nowTime = this.s2hms(
          (this.$refs.audioDom.duration * percent) / 100
        );

        this.percent = percent;
        this.audioPercent = left;

        // this.$refs.sliderLeft.style.width = left;
      }
    },
    s2hms(time) {
      var min = Math.floor(time % 3600);
      var hh =
        Math.floor(time / 3600) < 10
          ? "0" + Math.floor(time / 3600)
          : Math.floor(time / 3600);
      var mm =
        Math.floor(min / 60) < 10
          ? "0" + Math.floor(min / 60)
          : Math.floor(min / 60);
      var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
      return hh + ":" + mm + ":" + ss;
      // console.log(hh + ":" + mm + ":"+ ss)
    },
    audioLoad() {
      // console.log(this.$refs.audioDom.duration)
      let that = this;
      that.duration = parseInt(that.$refs.audioDom.duration);
      that.endTime = that.s2hms(parseInt(that.$refs.audioDom.duration));
      console.log(that.$refs.audioDom.duration,that.endTime)
      if(isNaN(that.$refs.audioDom.duration)){
        that.endTime = '00:00:00'
      }
      that.nowTime = that.s2hms(parseInt(that.$refs.audioDom.currentTime));
      if(isNaN(that.nowTime)){
        that.nowTime = '00:00:00'
      }
      var percent =
        (
          (parseInt(that.$refs.audioDom.currentTime) /
            parseInt(that.$refs.audioDom.duration)) *
          100
        ).toFixed(2) + "%";
      that.audioPercent = percent;

      // this.$refs.audioDom.play();
      this.isPlay = false;

      this.$refs.audioDom.ontimeupdate = function (e) {
        that.nowTime = that.s2hms(parseInt(e.target.currentTime));
        let percent =
          (
            (parseInt(e.target.currentTime) / parseInt(e.target.duration)) *
            100
          ).toFixed(2) + "%";
        that.audioPercent = percent;
      };

      this.$refs.audioDom.onended = function () {
        that.isPlay = false;
      };
    },
    closeDownloadBox() {
      this.showDownloadBtn = false
    }
  },
  mounted() {
    // this.$authTable()
    // this.$Dialog({
    // }).then(res => {
    //   if(res != 'false'){
    //     console.log(res)
    //   }
    // })
    let resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
    window.addEventListener(resizeEvt, this.recalc, false);
    document.addEventListener("DOMContentLoaded", this.recalc, false);

    this.recalc()
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    // this.getData()
    this.checkType();
    this.getPageVersion();
    // this.getRptLife();
    // this.getVersions();
    this.handleAutoLock();
    this.setAutoLock()
    common.handleSocket(this.getTranstext, "pickuptext");
    common.handleSocket(this.getTranscode, "transcode");
    common.handleSocket(this.showCloseTips, "newmedia_edit");
    this.disableContextMenu()
  }
};
</script>

<style src="@assets/css/newMediaDetail/mediaDetails.less" lang="less" scoped></style>
<style lang="less" scoped>
  .remainText {
    color: #f54545;
    margin-left: 8px;
  }
  .newDownloadBox {
    position: relative;
    width: fit-content;

    .btn {
      position: absolute;
      bottom: 50px;
      left: 14px;


      & > ul {
        background-color: rgba(5, 15, 15, 0.8);
        & > li {
          height: 40px;
          // background-color: rgba(5, 15, 15, 0.8);
          display: flex;
          padding: 0 20px;
          cursor: pointer;
          font-size: 13px;
          color: #fff;
          align-items: center;
          white-space: nowrap;

          i {
            margin-left: 10px;
          }
        }
      }
    }
  }

  article {
    flex: 1;
    min-height: 0;
  }
  .tips-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 1000;

        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);
        }

        .tips-content {
            display: flex;
            flex-direction: column;
            width: 432px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            padding: 32px 32px 24px;
            box-sizing: border-box;

            .title {
                font-size: 16px;
                line-height: 24px;
                color: #323B4B;
                font-weight: bold;
                margin-bottom: 12px;
            }

            &>div {
                &:nth-of-type(1) {
                    margin-bottom: 14px;
                }
            }

            .noKnews {
                font-size: 14px;
                line-height: 22px;
                color: #666666;

                span {
                    color: #41B48C;
                }
            }

            .Knews {
                font-size: 14px;
                line-height: 22px;
                color: #666666;

                span {
                    color: #41B48C;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                margin-top: 24px;

                p {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 65px;
                    height: 32px;
                    font-size: 14px;
                    background: #B9C3C3;
                    color: #FFF;
                    border-radius: 4px;
                    user-select: none;
                    cursor: pointer;

                    &.green {
                        background: #41B48C;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
  .newNotice {
    display: flex;
    justify-content: flex-end;
    font-size: 13px;
    color: #b9c3c3;
    font-weight: bold;
    margin-top: 4px;
  }
  .folded {
    .dyAnalysis {
      display: none;
    }
  }
  .dyAnalysis {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 210px;
    padding: 30px;
    box-sizing: border-box;

    .un {
      p {
        color: #E6E6E6;
      }
    }

    &>div {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50%;

      &:nth-of-type(1) {
        div {
          &:nth-of-type(1) {
            border-bottom: 1px solid #E6E6E6;
            border-right: 1px solid #E6E6E6;
            box-sizing: border-box;
          }
          &:nth-of-type(2) {
            border-bottom: 1px solid #E6E6E6;
            box-sizing: border-box;
          }
        }
      }

      &:nth-of-type(2) {
        div {
          &:nth-of-type(1) {
            border-right: 1px solid #E6E6E6;
            box-sizing: border-box;
          }
        }
      }

      div {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
          font-size: 24px;
          line-height: 28px;
          color: #41B48C;
          font-weight: bold;
          margin-bottom: 11px;
        }

        span {
          font-size: 12px;
          line-height: 17px;
          color: #829191;
          font-weight: bold;
        }
      }
    }
  }

  .writeContent {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 40px;
    width: 100%;
  }

  .writeArticleContent {
    width: 100%;
    padding: 22px 20px 28px;
    box-sizing: border-box;
    background-color: rgba(185, 195, 195, 0.1);
    border-radius: 4px;
    .title {
      font-size: 16px;
      line-height: 30px;
      color: #050F0F;
    }
  }
</style>
<style lang="less">
.infoBox {
  .details {
    p {
      word-break: normal !important;
      word-wrap:break-word !important;
    }
  }
}

.articleContent em {
  display: inline-block;
  padding: 0 10px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: rgba(65, 180, 140, 0.1);
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  color: #41B48C;
  margin: 0 5px;
  font-style: normal;
  font-weight: bold;
}

.videoContent {
  .writeContent {

    video {
      max-width: 100%;
    }

    p {
      span {
        white-space: break-spaces !important;
      }
    }

    .imgContainer {
      display: flex;
      flex-direction: column;
      align-items: center;
      // width: fit-content;
      max-width: 100%;

      & > .img {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }

      .relative {
        display: flex;
        flex-direction: column;
        align-items: center;
        word-break: break-all;
      }

      .centerTxt {
        display: none;
        width: 100%;
        // justify-content: center;
        text-align: center;
        font-size: 16px;
        line-height: 30px;
        color: #829191;
        margin-top: 30px;
      }

      img {
        max-width: 100%;
      }

      img + .centerTxt {
        display: block;
      }

      img + span .centerTxt {
        display: block;
        font-style: normal;
      }
    }
  }
}

.mediaPublishDetail {
  .leftContainer {
    img {
      max-width: 100%;
    }
  }
}

.detailContainer .detail .c span {
  white-space: nowrap;
}
</style>